
import Vue from 'vue';
import store from '@/store';
import { mapGetters, mapActions, mapState } from 'vuex';
import users from '@/services/users.js';
import Gleap from 'gleap';
import stores2 from '@/services/stores';

export default {
  data() {
    return {
      model: true,
      step: 1,
      selected: null,
      isStoreMulti: true,
      survey: [],
      stores: [],
      stringOptions: [],
      options: [],
      firstName: '',
      storeInfo: []
    };
  },

  computed: {
    ...mapGetters('store', ['getAllStoreInfo']),
    ...mapState('store', { storeStores: 'stores' }),
    ...mapGetters('user', ['getLocale']),
    getSurvey() {
      return [
        {
          label: this.$store.state.user.translateWhole.survey_option1[
            this?.getLocale
          ],
          value: 'Store Employee',
          needStore: true
        },
        {
          label: this.$store.state.user.translateWhole.survey_option2[
            this?.getLocale
          ],
          value: 'Store Manager or Assistant Store Manager',
          needStore: true
        },
        {
          label: this.$store.state.user.translateWhole.survey_option3[
            this?.getLocale
          ],
          value: 'Area Manager',
          needStore: true
        },
        {
          label: this.$store.state.user.translateWhole.survey_option4[
            this?.getLocale
          ],
          value: 'Visual Merchandiser (VMD)',
          needStore: true
        },
        {
          label: this.$store.state.user.translateWhole.survey_option5[
            this?.getLocale
          ],
          value: 'Head Office - Marketing',
          needStore: true
        },
        {
          label: this.$store.state.user.translateWhole.survey_option6[
            this?.getLocale
          ],
          value: 'Head Office - Sales',
          needStore: true
        },
        {
          label: this.$store.state.user.translateWhole.survey_option7[
            this?.getLocale
          ],
          value: 'Head Office - IT or Operations (Admin)',
          needStore: true
        },
        {
          label: this.$store.state.user.translateWhole.survey_option8[
            this?.getLocale
          ],
          value: 'Head Office - Corporate Management',
          needStore: true
        },
        {
          label: this.$store.state.user.translateWhole.survey_option9[
            this?.getLocale
          ],
          value: 'Head Office - Human Resources & General Affairs Dept',
          needStore: true
        },
        {
          label: this.$store.state.user.translateWhole.survey_option10[
            this?.getLocale
          ],
          value: 'Head Office - Other',
          needStore: true
        },
        {
          label: this.$store.state.user.translateWhole.survey_option11[
            this?.getLocale
          ],
          value: 'Other, not listed above',
          needStore: true
        }
      ];
    }
  },

  watch: {
    model(newValue) {
      this.isModalShow(newValue);
    },
    async storeStores() {
      console.log('getAllStoreInfo', this.storeStores);
    },
    getLocale() {
      console.log(
        'mounted',
        this.$store.state.user.translateWhole.survey_option1[this?.getLocale]
      );
    }
  },

  async mounted() {
    this.firstName = store.getters['user/getProfile'].firstName;
  },

  methods: {
    ...mapActions('user', ['updateProfileSSO', 'userDetailHandler']),
    ...mapActions('overview', ['isModalShow']),

    // --- Helper: Mixpanel persistent user attribute ---
  setMixpanelUserProfile(profile, jobRole) {
    if (!Vue.prototype.$mixpanel) return;
    Vue.prototype.$mixpanel.people.set({
      job_role: jobRole,
      email: profile?.email
    });
  },

  // --- Helper: Mixpanel contextual event ---
  trackMixpanelEvent(jobRole) {
    if (!Vue.prototype.$mixpanel) return;
    Vue.prototype.$mixpanel.track('User Onboarding', {
      job_role: jobRole
    });
  },

  // --- NEW: Gleap user segmentation helper ---
  setGleapUserProfile(profile, jobRole) {
    if (!Gleap) return;
    Gleap.identify(profile?._id || profile?.email, {
      name: `${profile?.firstName || ''} ${profile?.lastName || ''}`,
      email: profile?.email,
      job_role: jobRole,
    });
  },

    selectedProfile(o) {
      this.selected = o.value;
      this.needStore = o.needStore;
      this.isStoreMulti = !(
        o.value == 'Store Employee' ||
        o.value == 'Store Manager or Assistant Store Manager'
      );
    },

    goBack() {
      if (this.step == 3) {
        this.goTo(this.needStore ? 2 : 1);
      } else {
        this.goTo(1);
      }
    },

    async goTo(val) {
      if (this.needStore) {
        if (val == 2) {
          this.stringOptions = store.getters['user/getStoresCodeNameList'].map(
            a => {
              return {
                label: `${a.storeCode} ${a.name}`,
                value: a.storeCode,
                storeName: a.name,
                storeCode: a.storeCode
              };
            }
          );
          if (this.isStoreMulti) {
            this.stores = [];
            this.stringOptions.forEach(st => {
              let cSt = this.storeStores.myStores.filter(
                a => a.storeNumber == st.storeCode
              );
              if (cSt.length) {
                cSt = cSt[0];
                let cStItem = {
                  label: `${cSt.storeNumber} ${cSt.title}`,
                  value: cSt.storeNumber,
                  storeName: cSt.title,
                  storeCode: cSt.storeNumber
                };
                this.stores.push(cStItem);
              }
            });
          } else {
            this.stores = [];
            this.stringOptions.forEach(st => {
              let cSt = this.storeStores.myStores.filter(a => {
                let f = this.stringOptions.filter(
                  b => a.storeNumber == b.storeCode
                );
                return f.length > 0;
              });
              if (cSt.length) {
                cSt = cSt[0];
                let cStItem = {
                  label: `${cSt.storeNumber} ${cSt.title}`,
                  value: cSt.storeNumber,
                  storeName: cSt.title,
                  storeCode: cSt.storeNumber
                };
                this.stores = cStItem;
              }
            });
          }
        }

        if (val == 3) {
          let { profile } = store.state['user'];
         // --- Mixpanel: persistent + event context ---
        this.setMixpanelUserProfile(profile, this.selected);
        this.trackMixpanelEvent(this.selected);

        // --- Gleap: segmentation user context ---
        this.setGleapUserProfile(profile, this.selected);

          let locations = [];
          if (this.isStoreMulti) {
            locations = [
              {
                type: 'mystores',
                storeCodes: this.stores.map(st => st.storeCode)
              }
            ];
          } else {
            locations = [
              {
                type: 'mystores',
                storeCodes: [this.stores.storeCode]
              }
            ];
          }

          let UsrDetails = {
            userId: profile._id,
            locations
          };

          // update backend role too
          await this.updateProfileSSO({ role: this.selected });

          users
            .setUserLocations(UsrDetails)
            .then(() => {})
            .catch(error => {
              this.$q.notify({
                message: error,
                color: 'red'
              });
            });
        }

        if (this.isStoreMulti) {
          if (!Array.isArray(this.stores)) {
            this.stores = [this.stores];
          }
        } else {
          if (Array.isArray(this.stores)) {
            this.stores = this.stores[0];
          }
        }

        this.userDetailHandler();
      } else {
        if (val == 2) {
          val = 3;
        }
      }
      this.step = val;
    },

    createValue(val, done) {
      if (val.length > 0) {
        if (!this.stringOptions.includes(val)) {
          this.stringOptions.push(val);
        }
        done(val, 'toggle');
      }
    },

    filterFn(val, update) {
      update(() => {
        if (val === '') {
          this.options = this.stringOptions;
        } else {
          const needle = val.toLowerCase();
          this.options = this.stringOptions.filter(
            v => v.toLowerCase().indexOf(needle) > -1
          );
        }
      });
    }
  }
};
